import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-pliny-the-younger',
  imports: [Link, RouterLink],
  templateUrl: './pliny-the-younger.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pliny-the-younger.scss',
})
export class PlinyTheYounger {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Pliny the Younger`);
    this.dynamicTitle.description(`Pliny the Younger was a Roman governor and writer who lived in the 1st century. He does not provide evidence for the existence of Jesus as a historical figure.`);
  }
}
